<div class="recent-orders">
    <div class="title-buttons d-flex justify-content-between align-items-center">
        <strong>Logistic Partners</strong>
    </div>

    <!-- Filter Section -->
    <div class="filter-section mb-3">
        <label class="me-2">Filter by Status:</label>
        <select class="form-select d-inline-block w-auto" [(ngModel)]="statusFilter" (change)="onStatusFilterChange($any($event.target).value)">
            <option value="ALL">All</option>
            <option value="PENDING">Pending</option>
            <option value="COMPLETED">Completed</option>
            <option value="VERIFIED">Verified</option>
            <option value="REJECTED">Rejected</option>
        </select>
    </div>

    <div class="table-responsive">
        <table class="table table-striped" id="logistic-partners-table">
            <thead>
                <tr class="first last">
                    <th>Display Name</th>
                    <th>Partner Type</th>
                    <th>Status</th>
                    <th>Payment Method</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody *ngIf="loading">
                <tr>
                    <td colspan="5" style="text-align: center">Loading ...</td>
                </tr>
            </tbody>
            <tbody *ngIf="!loading && filteredPartners.length === 0">
                <tr>
                    <td colspan="5" style="text-align: center">No logistic partners found</td>
                </tr>
            </tbody>
            <tbody *ngIf="!loading && filteredPartners.length > 0">
                <tr *ngFor="let partner of filteredPartners | paginate: config">
                    <td>{{ getDisplayName(partner) }}</td>
                    <td>
                        <span class="badge" [ngClass]="partner.carrierType === 'company' ? 'bg-primary' : 'bg-secondary'">
                            {{ partner.carrierType === 'company' ? 'Company' : 'Private' }}
                        </span>
                    </td>
                    <td>
                        <span [ngClass]="getStatusClass(partner.status)">
                            {{ partner.status }}
                        </span>
                    </td>
                    <td>{{ getPaymentMethod(partner) }}</td>
                    <td>
                        <button class="btn btn-sm btn-outline-primary" (click)="viewPartnerDetails(partner)">
                            View Details
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="toolbar" *ngIf="!loading && filteredPartners.length > 0">
        <div class="pager">
            <pagination-controls
                class="pages"
                maxSize="5"
                previousLabel="Previous"
                nextLabel="Next"
                autoHide="true"
                id="logistic-partners-listing"
                (pageChange)="pageChange($event)">
            </pagination-controls>
        </div>
    </div>
</div>
